import { getAffairStage, getAllowedAffairTransitions, isAffairFinal } from '../affairModel';

const FINAL_ACTION_LABELS = {
  won: 'Marquer comme gagnée',
  lost: 'Marquer comme perdue',
  abandoned: 'Abandonner l’affaire',
};

export default function AffairStageActions({ affair, disabled = false, onTransition }) {
  if (isAffairFinal(affair.stage)) return null;

  const allowed = getAllowedAffairTransitions(affair.stage);
  const finalActions = allowed.filter((stageKey) => FINAL_ACTION_LABELS[stageKey]);

  return (
    <div className="affair-stage-actions" aria-label={`Actions pour l’étape ${getAffairStage(affair.stage).label}`}>
      {/* {previous && <button className="basic-button" type="button" disabled={disabled} onClick={() => onTransition(affair, previous.key)}>Étape précédente</button>}
      {next && <button className="basic-button active" type="button" disabled={disabled} onClick={() => onTransition(affair, next.key)}>Passer en {next.label.toLowerCase()}</button>} */}
      {finalActions.map((stageKey) => (
        <button className={`basic-button affair-stage-actions__${stageKey}`} type="button" disabled={disabled} key={stageKey} onClick={() => onTransition(affair, stageKey)}>
          {FINAL_ACTION_LABELS[stageKey]}
        </button>
      ))}
    </div>
  );
}
